import { HistoryOutlined, UserOutlined, TrophyOutlined, CalendarOutlined, BookOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { Menu } from 'antd';
import React from 'react';

import useWindowDimensions from '../../hooks/useWindowDimensions';
import './index.scss';

function getItem(label, key, icon, children, theme) {
  return {
    key,
    icon,
    children,
    label,
    theme,
  };
}

const sideItems = [
  getItem('Events', '1', <CalendarOutlined style={{ fontSize: 20 }} />),
  getItem(
    'Orders',
    '2',
    <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20.75 6.40625H18.2188V3.74375C18.2188 3.32891 17.8836 2.99375 17.4688 2.99375H10.0859L7.33672 0.364062C7.30174 0.331315 7.25573 0.312911 7.20781 0.3125H1.25C0.835156 0.3125 0.5 0.647656 0.5 1.0625V14.9375C0.5 15.3523 0.835156 15.6875 1.25 15.6875H17.6094C17.9141 15.6875 18.1906 15.5023 18.3055 15.2188L21.4461 7.4375C21.4813 7.34844 21.5 7.25234 21.5 7.15625C21.5 6.74141 21.1648 6.40625 20.75 6.40625ZM2.1875 2H6.60547L9.40859 4.68125H16.5312V6.40625H4.57812C4.27344 6.40625 3.99688 6.59141 3.88203 6.875L2.1875 11.075V2ZM17.0773 14H2.72656L5.14766 8H19.5008L17.0773 14Z"
        fill="black"
        fillOpacity="0.88"
      />
    </svg>
  ),
  // getItem(
  //   'My Tickets',
  //   '5',
  //   <svg
  //     xmlns="http://www.w3.org/2000/svg"
  //     width="24"
  //     height="24"
  //     viewBox="0 0 24 24"
  //     fill="none"
  //     stroke="#000000"
  //     strokeWidth="2"
  //     strokeLinecap="round"
  //     strokeLinejoin="round"
  //   >
  //     <circle cx="10" cy="20.5" r="1" />
  //     <circle cx="18" cy="20.5" r="1" />
  //     <path d="M2.5 2.5h3l2.7 12.4a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.6l1.6-8.4H7.1" />
  //   </svg>
  // ),
  getItem('Saved Entries', '6', <HistoryOutlined style={{ fontSize: 20 }} />),
  getItem('Awards', '7', <TrophyOutlined style={{ fontSize: 20 }} />),
  // getItem(
  //   <>
  //     <span style={{ paddingRight: 10 }}>Tasting Notes</span>
  //     <Tag color="gold" style={{ borderColor: '#fffbe6' }}>
  //       Beta
  //     </Tag>
  //   </>,
  //   '4',
  //   <svg
  //     width="20"
  //     height="22"
  //     xmlns="http://www.w3.org/2000/svg"
  //     fill="none"
  //     viewBox="0 0 448 512"
  //     className="ant-menu-item-icon"
  //   >
  //     <path
  //       d="M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V384c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zm0 384H352v64H96c-17.7 0-32-14.3-32-32s14.3-32 32-32zm32-240c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zm16 48H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
  //       fill="black"
  //       fillOpacity="0.88"
  //     />
  //   </svg>
  // ),
  getItem(
    <>
      <span style={{ paddingRight: 10 }}>Tasting Notes</span>
    </>,
    '8',
    <BookOutlined style={{ fontSize: 20 }} />
  ),
  getItem('Users', '4', <UserOutlined style={{ fontSize: 18 }} />),
  getItem(
    'Settings',
    '3',
    <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.676 13.6633L18.1408 12.3508C18.2135 11.9055 18.251 11.4508 18.251 10.9961C18.251 10.5414 18.2135 10.0867 18.1408 9.64142L19.676 8.32892C19.7918 8.22979 19.8746 8.09777 19.9136 7.9504C19.9525 7.80303 19.9457 7.6473 19.8939 7.50392L19.8728 7.44298C19.4502 6.26179 18.8174 5.16681 18.0049 4.21095L17.9627 4.16173C17.8641 4.04584 17.7328 3.96253 17.5859 3.92278C17.439 3.88303 17.2836 3.88871 17.14 3.93907L15.2346 4.61642C14.5314 4.03986 13.7463 3.58517 12.8978 3.26642L12.5299 1.27423C12.5021 1.12433 12.4294 0.986424 12.3214 0.878835C12.2134 0.771246 12.0752 0.699067 11.9252 0.671887L11.8619 0.660168C10.6408 0.439856 9.35644 0.439856 8.13534 0.660168L8.07206 0.671887C7.92206 0.699067 7.78387 0.771246 7.67586 0.878835C7.56785 0.986424 7.49514 1.12433 7.46737 1.27423L7.09706 3.27579C6.2554 3.59461 5.47159 4.04906 4.77675 4.62111L2.85722 3.93907C2.7137 3.88831 2.55814 3.88243 2.41119 3.9222C2.26425 3.96197 2.13289 4.04551 2.03456 4.16173L1.99238 4.21095C1.18084 5.16749 0.5481 6.26229 0.124407 7.44298L0.103313 7.50392C-0.00215593 7.79689 0.0845629 8.12501 0.321282 8.32892L1.87519 9.65548C1.80253 10.0961 1.76738 10.5461 1.76738 10.9938C1.76738 11.4438 1.80253 11.8938 1.87519 12.332L0.321282 13.6586C0.20549 13.7577 0.122617 13.8898 0.0836816 14.0371C0.0447461 14.1845 0.0515933 14.3402 0.103313 14.4836L0.124407 14.5445C0.548625 15.7258 1.17675 16.8156 1.99238 17.7766L2.03456 17.8258C2.13313 17.9417 2.26449 18.025 2.41135 18.0647C2.5582 18.1045 2.71366 18.0988 2.85722 18.0485L4.77675 17.3664C5.47519 17.9406 6.25566 18.3953 7.09706 18.7117L7.46737 20.7133C7.49514 20.8632 7.56785 21.0011 7.67586 21.1087C7.78387 21.2163 7.92206 21.2885 8.07206 21.3156L8.13534 21.3274C9.36766 21.5488 10.6296 21.5488 11.8619 21.3274L11.9252 21.3156C12.0752 21.2885 12.2134 21.2163 12.3214 21.1087C12.4294 21.0011 12.5021 20.8632 12.5299 20.7133L12.8978 18.7211C13.7459 18.4032 14.5355 17.947 15.2346 17.3711L17.14 18.0485C17.2835 18.0992 17.4391 18.1051 17.5861 18.0653C17.733 18.0256 17.8644 17.942 17.9627 17.8258L18.0049 17.7766C18.8205 16.8133 19.4486 15.7258 19.8728 14.5445L19.8939 14.4836C19.9994 14.1953 19.9127 13.8672 19.676 13.6633ZM16.4767 9.91798C16.5353 10.2719 16.5658 10.6352 16.5658 10.9984C16.5658 11.3617 16.5353 11.725 16.4767 12.0789L16.3221 13.0188L18.0728 14.5164C17.8074 15.1279 17.4724 15.7067 17.0744 16.2414L14.8994 15.4703L14.1635 16.075C13.6033 16.5344 12.9799 16.8953 12.3049 17.1485L11.4119 17.4836L10.9924 19.757C10.3304 19.832 9.66213 19.832 9.00019 19.757L8.58066 17.4789L7.69472 17.1391C7.02675 16.886 6.40566 16.525 5.85019 16.068L5.11425 15.461L2.92519 16.2391C2.52675 15.7024 2.19394 15.1235 1.92675 14.5141L3.69628 13.0024L3.54394 12.0649C3.48769 11.7156 3.45722 11.3547 3.45722 10.9984C3.45722 10.6399 3.48534 10.2813 3.54394 9.93204L3.69628 8.99454L1.92675 7.48282C2.19159 6.87111 2.52675 6.29454 2.92519 5.75782L5.11425 6.53595L5.85019 5.92892C6.40566 5.47189 7.02675 5.11095 7.69472 4.85782L8.583 4.52267L9.00253 2.24454C9.66113 2.16954 10.3338 2.16954 10.9947 2.24454L11.4142 4.51798L12.3072 4.85314C12.9799 5.10626 13.6057 5.4672 14.1658 5.92657L14.9017 6.53126L17.0768 5.76017C17.4752 6.29689 17.808 6.87579 18.0752 7.48517L16.3244 8.98282L16.4767 9.91798ZM10.001 6.63907C7.72284 6.63907 5.87597 8.48595 5.87597 10.7641C5.87597 13.0422 7.72284 14.8891 10.001 14.8891C12.2791 14.8891 14.126 13.0422 14.126 10.7641C14.126 8.48595 12.2791 6.63907 10.001 6.63907ZM11.8572 12.6203C11.6138 12.8645 11.3244 13.0581 11.0058 13.19C10.6873 13.322 10.3458 13.3896 10.001 13.3891C9.30019 13.3891 8.64159 13.1149 8.14472 12.6203C7.90056 12.3769 7.70694 12.0875 7.57501 11.769C7.44308 11.4504 7.37543 11.1089 7.37597 10.7641C7.37597 10.0633 7.65019 9.4047 8.14472 8.90782C8.64159 8.41095 9.30019 8.13907 10.001 8.13907C10.7017 8.13907 11.3603 8.41095 11.8572 8.90782C12.1014 9.15129 12.295 9.44063 12.4269 9.75919C12.5589 10.0778 12.6265 10.4193 12.626 10.7641C12.626 11.4649 12.3518 12.1235 11.8572 12.6203Z"
        fill="black"
        fillOpacity="0.88"
      />
    </svg>
  ),
];

const CustomSider = (props) => {
  const navigate = useNavigate();
  const { width } = useWindowDimensions();

  const handleSelection = (location) => {
    if (width <= 768) props.setCollapsed(true);
    navigate(location);
  };

  const onClick = (e) => {
    props.onSetCurrent(e.key);

    switch (e.key) {
      case '1':
        handleSelection('/');
        break;
      case '2':
        handleSelection('/order-history');
        break;
      case '3':
        handleSelection('/settings');
        break;
      case '4':
        handleSelection('/users');
        break;
      case '5':
        handleSelection(`/ticket-registration/${process.env.REACT_APP_EVENT_ID}?tab=2`);
        break;
      case '6':
        handleSelection(`/saved-entries`);
        break;
      case '7':
        handleSelection('/winners');
        break;
      case '8':
        handleSelection('/tasting-notes');
        break;
      default:
        break;
    }
  };
  return <Menu onClick={onClick} selectedKeys={[props.current]} items={sideItems} className="custom-sidebar" />;
};

export default CustomSider;
